export default __webpack_public_path__ + "static/6866-35967897d71bdfbe843f2955a0eb8dd2.jpg";